import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css, cx } from '../../styled';
const LayoutContent = ({ children, className, disablePadding }) => {
    return _jsx("div", Object.assign({ className: cx(className, { 'hst-sidebar-content-disable-padding': disablePadding }) }, { children: children }));
};
export default styled(LayoutContent, { label: 'hst-sidebar-content' })(({ theme }) => css `
    flex: 1;
    min-width: 0;
    background-color: ${theme.antd.colorBgLayout};
    transition: background-color 0.3s;

    &:not(.hst-sidebar-content-disable-padding) {
      padding: 2rem;

      ${theme.mediaQuery.down('sm')} {
        padding: 1rem;
      }
    }
  `);
